export const getState = () => ({
  user: {},
  image: false,
  session: {},
  isLogged: false,
});

export default Object.assign(getState(), { getState: getState });
